const configuredControlPlaneOrigin = (): string | undefined => {
  const value = process.env.REACT_APP_CONTROL_PLANE_ORIGIN?.trim();
  if (!value) return undefined;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' || parsed.hostname === 'localhost' ? parsed.origin : undefined;
  } catch {
    return undefined;
  }
};

export const getControlPlaneOrigin = (): string => {
  const configured = configuredControlPlaneOrigin();
  if (configured) return configured;
  if (window.location.hostname === 'localhost' || window.location.hostname.endsWith('.localhost')) {
    return window.location.origin;
  }
  if (process.env.REACT_APP_ENV === 'development') return 'https://booking-template-dev.web.app';
  return 'https://app.scheduify.com';
};

export const createControlPlaneTenantUrl = (
  pathname: string,
  tenantId: string,
  params: Record<string, string> = {},
): string => {
  const target = new URL(pathname, getControlPlaneOrigin());
  target.searchParams.set('tenant', tenantId);
  Object.entries(params).forEach(([key, value]) => target.searchParams.set(key, value));
  return target.toString();
};

export const createControlPlaneUrl = (
  pathname: string,
  params: Record<string, string> = {},
): string => {
  const target = new URL(pathname, getControlPlaneOrigin());
  Object.entries(params).forEach(([key, value]) => target.searchParams.set(key, value));
  return target.toString();
};
